var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_FINAL",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454.2 102.3",
    style: {
      enableBackground: "new 0 0 454.2 102.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:none;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -30.7,
    y: -30.7,
    className: "st0",
    width: 515.6,
    height: 163.7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.9,48.2l-40.3-3.3c-3.3-0.3-3.9-1.4-3.9-3.4c0-1.8,1-2.9,3.5-2.9h49.8v-7.9H168c-7.3,0-12.3,2.8-12.3,10.9c0,8.2,3.8,10.9,12.1,11.6l40.4,3.4c3.1,0.3,4,1.3,4,3.5c0,2.1-1,3.4-3.7,3.4h-50.7v8h51.6c8.9,0,12.8-3.5,12.8-11.9C222.1,52,218.6,49,209.9,48.2z M0,57l83.6,14.3c-1.7,2.7-5.1,3.4-7.6,3.4c-3.2,0-15.3-0.1-20-0.1c-18.5,0-41.2-0.7-56-1.7c0.2,3.7,0.7,14.9,1,18.7c0.4,5.7,0.6,6.7,2,7.7c0.7,0.4,1.9,1.1,5.2,1.3c31.9,2.2,57.3,2.4,82.3,1.1c10.8-0.6,15.3-1.4,19.2-4.8c2.8-2.5,4.2-6.6,4.5-13.4c0.2-5.7,0.4-15.6,0.5-18.7L0,43.1V57z M36.1,26.2c1.7-0.2,16.4-0.5,32.6-0.3C85,26,103.6,27,114.6,27.5c-0.2-4.7-0.7-13.4-0.9-16.6c-0.4-5.7-0.6-6.7-2-7.7c-0.7-0.4-1.9-1.1-5.2-1.3C74.7-0.3,49.2-0.5,24.3,0.9C13.5,1.4,9,2.3,5.1,5.7c-2.8,2.5-4.2,6.6-4.5,13.4c-0.2,5.3-0.4,14.3-0.5,18L114.8,57V44.7L30.4,29C30.9,28.3,32.5,26.6,36.1,26.2z M236.1,57.5c0,9.2,5,14.1,15.9,14.1h47.7v-8h-45.1c-6.3,0-7.5-2.1-7.5-7.8v-1.3h50.5v-7.8H247v-8h52.7v-8h-63.5V57.5z M392.5,30.7v8h25.4v32.9h10.8V38.7h25.5v-8H392.5z M316.4,45.6v25.9h10.8V59.7h41.2v11.9h10.8V30.7h-47C321.4,30.7,316.4,36.4,316.4,45.6z M368.4,38.7v12.9h-41.2V48c0-5.6,0.9-9.3,7.5-9.3H368.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.33d4f9321b8eaebcfccd38ca9ee83fa5.svg";
export { ForwardRef as ReactComponent };